module.exports = __webpack_public_path__ + "img/ciminal_person2.6591c449.png";